import { useAuth } from "../hooks/useAuth";
import { UserPublic } from "../types";

export const ROLE_LABELS: Record<string, string> = {
  admin: "Admin", kam: "Key account manager", hmp: "Hiring manager", partner_admin: "Partner Admin",
};

export const isAdmin        = (u: UserPublic | null | undefined): boolean => u?.role === "admin";
export const isKam          = (u: UserPublic | null | undefined): boolean => u?.role === "kam";
export const isHmp          = (u: UserPublic | null | undefined): boolean => u?.role === "hmp";
export const isPartnerAdmin = (u: UserPublic | null | undefined): boolean => u?.role === "partner_admin";
export const canEdit        = (u: UserPublic | null | undefined): boolean => isAdmin(u) || isKam(u);
export const canManageUsers = (u: UserPublic | null | undefined): boolean => isAdmin(u);
// Mirrors backend roles.ActsAsKAM: a KAM, or an admin opted in via
// can_act_as_kam. Holds KAM identity (assignable as KAM, partner grants, KAM
// alert types); KAM-only narrowing still checks isKam exactly.
export const actsAsKam = (u: { role: string; can_act_as_kam?: boolean } | null | undefined): boolean =>
  u?.role === "kam" || (u?.role === "admin" && !!u.can_act_as_kam);

export function useRole() {
  const { user } = useAuth();
  return {
    user,
    isAdmin:        isAdmin(user),
    isKam:          isKam(user),
    isHmp:          isHmp(user),
    isPartnerAdmin: isPartnerAdmin(user),
    canEdit:        canEdit(user),
    canManageUsers: canManageUsers(user),
    actsAsKam:      actsAsKam(user),
  };
}
